import { some } from 'lodash';

export class FindPlant{
  isRealPlant: boolean = false;
  constructor(plants: any, location: any){
    const plantParam :string = location.pathname.split('/').length > 2 && location.pathname.split('/')[2];
    this.isRealPlant = some(plants, {'code': plantParam});
  }
}
